<template>
  <v-container id="page-terms-list">
    <div class="page-title">{{$route.name}}</div>
    <v-col class="d-flex justify-end">
      <c-btn v-if="userInfo.role == 'SA'" color="blue" class="ml-1" outlined iconName="add" @click="onTypeDialog">약관 유형 관리</c-btn>
      <c-btn v-if="userInfo.role == 'SA'" color="blue" class="ml-1" outlined iconName="add" @click="onWriteTerms">약관 등록</c-btn>
    </v-col>
    <c-table
      :headers="termsTableHeaders"
      itemKey="id"
      :items="termsList"
    >
      <template #type="{ item }">
        {{ item.typeId.termsType }}
      </template>
      <template #appType="{item}">
        {{item.typeId.appType ? item.typeId.appType.configName : '-'}}
      </template>
      <template #details="{ item }">
        <c-btn icon iconName="search" @click="onPageRoute(item.typeId)"/>
      </template>
      <template #created="{ item }">
        {{ $func.dateTimeToString(item.created) }}
      </template>
    </c-table>

    <!-- 타입 관리 Dialog -->
    <v-dialog width="500" v-model="typeFlag">
      <c-card class="white" title="약관 유형 관리">
        <v-row class="pr-3">
          <v-col cols="12">
            <v-select
              label="앱 종류를 선택해주세요."
              v-model="selectedAppType"
              :items="appTypeList"
              solo dense
              item-text="configName"
              item-value="configValue"
              class="pb-0"></v-select>
          </v-col>
          <v-col cols="10">
            <v-text-field dense solo v-model="newTermsType" maxlength="1024"></v-text-field>
          </v-col>
          <v-col cols="2">
            <c-btn color="blue" @click="reqAddTermsType">추가</c-btn>
          </v-col>
        </v-row>
        <v-divider class="mb-3"></v-divider>
        <v-row v-for="(type, idx) in termsTypeList" :key="idx" class="pl-2">
          <v-col cols="9" class="pb-0">
            <v-text-field v-if="editableFlag === idx" outlined dense v-model="type.termsType"></v-text-field>
            <div v-else class="font-weight-bold subtitle-2">{{ type.termsType }}  ( {{type.appType.configName}} 용) </div>
          </v-col>
          <v-col cols="3" class="pb-0">
            <c-btn icon iconName="check" v-if="editableFlag === idx" @click="reqUpdateTermsType(type)" />
            <div v-else>
              <c-btn icon iconName="edit" @click="onChangeEditable(idx)"/>
              <c-btn icon iconName="mdi-close" @click="reqDeleteTermsType(type)"/>
            </div>
          </v-col>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    data() {
      return {
        termsTableHeaders: [
          {
            text: '약관 유형',
            value: 'type',
            align: 'center',
            sortable: true,
          },
          {
            text: '앱 유형',
            value: 'appType',
            align: 'center',
            sortable: true,
          },
          {
            text: '제목',
            value: 'title',
            align: 'center',
            sortable: true,
          },
          {
            text: '작성일',
            value: 'created',
            align: 'center',
            sortable: true,
          },
          {
            text: '상세보기',
            value: 'details',
            align: 'center',
            sortable: false,
          },
        ],

        termsList: [],
        typeFlag: false,

        termsTypeList: [],
        activeItem: null,

        newTermsType: '',
        editableFlag: '',
        selectedAppType:'',
      }
    },
    activated() {
      this.reqGetTermsList();
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      appTypeList() {
        return this.$store.state.config.app_type;
      }
    },
    methods: {
      async reqGetTermsList() {
        try {
          const res = await this.$api.getTermsList();

          this.termsList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetTermsTypeList'});
        }
      },
      onTypeDialog() {
        this.typeFlag = true;
        this.newTermsType = '';
        this.editableFlag = '';
        this.reqGetTermsTypeList();
      },
      onChangeEditable(idx) {
        this.editableFlag = idx;
      },
      async reqGetTermsTypeList() {
        try {
          const res = await this.$api.getTermsTypeList();

          this.termsTypeList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetTermsTypeList'});
        }
      },
      async reqAddTermsType() {
        try {
          if (!!!this.selectedAppType) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '앱 종류를 선택해주세요.'});
            return
          }
          if (!!!this.newTermsType) return;
          
          const res = await this.$api.addTermsType(this.newTermsType, this.selectedAppType);

          this.termsTypeList = res.data;
          this.newTermsType = '';
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddTermsType'});
        }
      },
      async reqUpdateTermsType(type) {
        try {
          if(!type.termsType) return;
          const res = await this.$api.updateTermsType(type);

          this.editableFlag = '';
          this.termsTypeList = res.data;
          this.newTermsType = '';
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqUpdateTermsType'});
        }
      },
      async reqDeleteTermsType(type) {
        try {
          if (type.flag === 'T') {
            this.$store.commit('alert', {open: true, timeout: 2500, msg: "약관이 존재하므로 삭제할 수 없습니다."});
            return;
          }
          const res = await this.$api.deleteTermsType(type.id);

          this.termsTypeList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDeleteTermsType'});
        }
      },
      onCheckDeletable(id) {

      },
      onWriteTerms() {
        this.$router.push('/terms/write');
      },
      onPageRoute(typeId) {
        this.$router.push(`/terms/${typeId.id}`);
      },
    },
  }
</script>

<style scoped>

</style>
